import { createReducer, on } from '@ngrx/store';
import * as plutoActions from './pluto.actions';

import { Signer, UserData } from '@waves/signer';
import BN from '@utils/bn';

export interface IPlutoState {
  showLoginModal: boolean;
  showStakeUnstakeModal: boolean;
  showStakeUnstakeModalAction?: 'stake' | 'unstake';
  loginType?: plutoActions.LOGIN_TYPE;
  signer?: Signer;
  loginData?: UserData;
  walletBalance?: BN;
  stakeBalance?: BN;
}

export const plutoReducer = createReducer(
  {
    showLoginModal: false,
    showStakeUnstakeModal: false,
  } as IPlutoState,
  on(plutoActions.rehydrateData, (state, action) => {
    let result = {
      ...state,
    };

    if (state.walletBalance) {
      const walletBalance = new BN(
        state.walletBalance.toString().replaceAll('"', ''),
      );
      result = {
        ...result,
        walletBalance: walletBalance,
      };
    }

    if (state.stakeBalance) {
      const stakeBalance = new BN(
        state.stakeBalance.toString().replaceAll('"', ''),
      );
      result = {
        ...result,
        stakeBalance: stakeBalance,
      };
    }

    return result;
  }),
  on(plutoActions.showLoginModal, (state) => ({
    ...state,
    showLoginModal: true,
  })),
  on(plutoActions.hideLoginModal, (state) => ({
    ...state,
    showLoginModal: false,
  })),
  on(plutoActions.showStakeUnstakeModal, (state, { action }) => ({
    ...state,
    showStakeUnstakeModal: true,
    showStakeUnstakeModalAction: action,
  })),
  on(plutoActions.hideStakeUnstakeModal, (state) => ({
    ...state,
    showStakeUnstakeModal: false,
  })),
  on(plutoActions.selectLoginType, (state, { loginType }) => ({
    ...state,
    loginType,
  })),
  on(plutoActions.logout, (state) => ({
    ...state,
    signer: undefined,
    loginData: undefined,
    walletBalance: undefined,
    stakeBalance: undefined,
  })),
  on(plutoActions.loginSuccess, (state, { signer, loginData }) => ({
    ...state,
    signer,
    loginData,
  })),
  on(plutoActions.getBalancesSuccess, (state, { wallet, stake }) => ({
    ...state,
    walletBalance: wallet,
    stakeBalance: stake,
  })),
);
